import { useConfig } from "$global-providers/config-provider/provider";

export default function useTimeZone(): string {
  const config = useConfig();
  const { territory } = config;

  switch (territory) {
    case "kenya":
      return "Africa/Nairobi";
    case "nigeria":
      return "Africa/Lagos";
    case "pakistan":
      return "Asia/Karachi";
    case "liberia":
      return "Africa/Monrovia";
    default:
      return "UTC";
  }
}
